export const NEW_BUYBOX_MODULE_NAME = 'cus-new-buybox';
